import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  documentNamesState,
  drawingNamesState,
  excludeDocumentNamesState,
  excludeDrawingNamesState,
  factoriesState,
  productItemsState,
  userState,
} from '../states/userState'
import { loadingState, loadingText } from '../states/LoadingState'
import { hasMoreState } from '../states/hasMoreState'
import apiClient from '../lib/apiClient'
import { factories as factoryList } from '../commons/factories'
const useFetchDrafts = () => {
  const user = useRecoilValue(userState)
  const drawingNames = useRecoilValue(drawingNamesState)
  const excludeDrawingNames = useRecoilValue(excludeDrawingNamesState)
  const documentNames = useRecoilValue(documentNamesState)
  const excludeDocumentNames = useRecoilValue(excludeDocumentNamesState)
  const factories = useRecoilValue(factoriesState)
  const productItems = useRecoilValue(productItemsState)
  const setLoadingAnimation = useSetRecoilState(loadingState)
  const setLoadingText = useSetRecoilState(loadingText)
  const setHasMore = useSetRecoilState(hasMoreState)
  const headquartersId = factoryList.find((f) => f.name === '本社工場')?.id
  const fetchDraftsByEnterKey = async (
    productNo = '',
    productBno = '',
    keywords = ''
  ) => {
    const requestBody = {
      productNo: productNo || user.filters.productNo.split('-')[0] || '',
      productBno: productBno || user.filters.productNo.split('-')[1] || '',
      keywords: keywords || user.filters.keywords,
      fromDate: user.filters.isUpdateEnable ? user.filters.drawingUpdFrm : '',
      toDate: user.filters.isUpdateEnable ? user.filters.drawingUpdTo : '',
      factories: factories?.length ? factories : [headquartersId],
      productItems,
      drawingNames,
      excludeDrawingNames,
      documentNames,
      excludeDocumentNames,
    }

    console.log('Request Body:', requestBody)

    try {
      setLoadingAnimation(true)
      setLoadingText('取得中...')
      const startTime = Date.now() // リクエスト前の時刻を記録
      const res = await apiClient.post(
        '/Drawing/getDrawingByDetailParams',
        requestBody
      )
      const endTime = Date.now() // リクエスト後の時刻を記録
      const duration = endTime - startTime // ミリ秒単位での時間差を計算

      console.log(`APIのフェッチ時間: ${duration}ms`)
      console.log('res.data', res.data, 'productNo', productNo)

      setHasMore(res.data.hasMore)
      return res.data.records
    } catch (error) {
      console.error('API Error:', error)
      window.alert(error)
      return null
    } finally {
      setLoadingAnimation(false)
      setLoadingText('')
    }
  }

  return { fetchDraftsByEnterKey }
}

export default useFetchDrafts
